export enum SRSBallotStatus {
  Created = 'Created',
  Scheduled = 'Scheduled',
  OnHold = 'On Hold',
  OpenForVoting = 'Open For Voting',
  ClosedForVoting = 'Closed For Voting',
  Deferred = 'Deferred',
  PendingClosure = 'Pending Closure',
  PendingApproval = 'Pending Approval',
  ReviewComplete = 'Review Complete',
}


export class Country {
  public static readonly NewZealand = ["new zealand", "nz"];
  public static readonly Australia = ["australia", "au"];
}

export const Location = {
  ALL: 'All',
  AUSTRALIA: 'Australia',
  NEWZEALAND: 'New Zealand'
};
